import Vue from 'vue'
import {join, pipe, pluck} from 'ramda'

Vue.filter('pluck', function(value, key) {
  return pipe(pluck(key), join(', '))(value)
})
